export const applyPencilDrawingEffect = async (canvas, ctx, setMessage, language) => {
  // 연필화 효과: 부드러운 그라데이션과 스케치 느낌
  // 1. 그레이스케일 변환
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  for (let i = 0; i < data.length; i += 4) {
    const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
    data[i] = gray;
    data[i + 1] = gray;
    data[i + 2] = gray;
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 네거티브 이미지 생성
  const negativeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const negativePixels = negativeData.data;
  
  for (let i = 0; i < negativePixels.length; i += 4) {
    negativePixels[i] = 255 - negativePixels[i];
    negativePixels[i + 1] = 255 - negativePixels[i + 1];
    negativePixels[i + 2] = 255 - negativePixels[i + 2];
  }
  
  // 3. 네거티브 이미지에 블러 적용
  const blurCanvas = document.createElement('canvas');
  blurCanvas.width = canvas.width;
  blurCanvas.height = canvas.height;
  const blurCtx = blurCanvas.getContext('2d');
  blurCtx.putImageData(negativeData, 0, 0);
  
  // 가우시안 블러 시뮬레이션
  const blurData = blurCtx.getImageData(0, 0, blurCanvas.width, blurCanvas.height);
  const blurPixels = blurData.data;
  const tempData = new Uint8ClampedArray(blurPixels);
  
  const blurRadius = 5;
  for (let y = blurRadius; y < canvas.height - blurRadius; y++) {
    for (let x = blurRadius; x < canvas.width - blurRadius; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        let sum = 0;
        let count = 0;
        
        for (let dy = -blurRadius; dy <= blurRadius; dy++) {
          for (let dx = -blurRadius; dx <= blurRadius; dx++) {
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance <= blurRadius) {
              const weight = Math.exp(-(distance * distance) / (2 * (blurRadius / 3) * (blurRadius / 3)));
              const neighborPos = ((y + dy) * canvas.width + (x + dx)) * 4;
              sum += tempData[neighborPos + c] * weight;
              count += weight;
            }
          }
        }
        
        blurPixels[pos + c] = sum / count;
      }
    }
  }
  
  blurCtx.putImageData(blurData, 0, 0);
  
  // 4. Color Dodge 블렌딩 모드 시뮬레이션
  const originalData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const originalPixels = originalData.data;
  const dodgeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const dodgePixels = dodgeData.data;
  
  for (let i = 0; i < originalPixels.length; i += 4) {
    for (let c = 0; c < 3; c++) {
      const base = originalPixels[i + c];
      const blend = blurPixels[i + c];
      
      // Color Dodge 공식: base / (1 - blend/255) * 255
      if (blend >= 255) {
        dodgePixels[i + c] = 255;
      } else {
        dodgePixels[i + c] = Math.min(255, (base * 255) / (255 - blend));
      }
    }
  }
  
  ctx.putImageData(dodgeData, 0, 0);
  
  // 5. 연필 질감 추가
  const textureData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const texturePixels = textureData.data;
  
  for (let i = 0; i < texturePixels.length; i += 4) {
    // 종이 질감 시뮬레이션
    if (Math.random() > 0.97) {
      const grain = (Math.random() - 0.5) * 30;
      for (let c = 0; c < 3; c++) {
        texturePixels[i + c] = Math.min(255, Math.max(0, texturePixels[i + c] + grain));
      }
    }
    
    // 연필 자국 방향성 추가
    const x = (i / 4) % canvas.width;
    const y = Math.floor((i / 4) / canvas.width);
    
    if (x % 3 === 0 || y % 3 === 0) {
      const strokeEffect = Math.sin(x * 0.1) * Math.sin(y * 0.1) * 10;
      for (let c = 0; c < 3; c++) {
        texturePixels[i + c] = Math.min(255, Math.max(0, texturePixels[i + c] + strokeEffect));
      }
    }
  }
  
  ctx.putImageData(textureData, 0, 0);
};